import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import moment from 'moment-timezone';
import axios from 'axios';
import { injectIntl } from "react-intl";
import { Avatar, Box, Button, Container } from '@material-ui/core';
import styles from './styles';
import Typography from '@material-ui/core/Typography';
import useGlobalContext from '../../../common/hooks/useGlobalContext';
import messages from "./messages";

const gray = 'rgba(0, 0, 0, 0.6)';

const RideDetails = props => {
  const { classes, fetchRides, fetchScheduledTrips, intl: { formatMessage, formatNumber } } = props;
  const {
    state: { activeService, rideInfo, tenantSettings },
    setLoading,
    setOpenRightDetailsPanel,
  } = useGlobalContext();
  const {
    expectedDuration,
    id,
    scheduledRide,
    status,
    startAddress,
    endAddress,
    driverName,
    payment,
    is_completed,
    vehicleDescription,
    licensePlate,
    riderName,
    riderNumber,
    numRiders,
  } = rideInfo;

  const cancelTrip = async () => {
    if (scheduledRide) {
      await axios.delete(`/api/v2/scheduledtriprequests/${id}`).finally(() => {
        setLoading(true);
        fetchScheduledTrips().finally(() => setLoading(false));
        setOpenRightDetailsPanel(false);
      });
    } else {
      const data = {
        cancelled_at: moment.tz(activeService.timeZone).format(),
        cancelled_by: 'business_admin',
      };
      await axios.patch(`/api/v2/trips/${id}`, data).finally(() => {
        setLoading(true);
        fetchRides().finally(() => setLoading(false));
        setOpenRightDetailsPanel(false);
      });
    }
  };

  const displayPackageDuration = () => {
    const { currency_code } = tenantSettings
    const matchingPackage = activeService.pricing.pricing_blocks.find(pkg => pkg.block_duration === expectedDuration)
    const { hours, minutes } = moment.duration(matchingPackage.block_duration, 'seconds')._data;

    return `${hours}hr${minutes > 0 ? ` ${minutes}min` : ''} - ${formatNumber(matchingPackage.price, {
      currency: currency_code,
      style: 'currency',
    })}`;
  };

  return (
    <Box style={{ marginLeft: 60, marginRight: 60, marginTop: '25%' }}>
      <Container className={classes.rideDetailsContainer}>
        <Avatar className={classes.rideDetailsAvatar} />
        <div>
          <Typography style={{ fontSize: 30, color: gray, lineHeight: 1.2 }}>
            {riderName}
          </Typography>
          <Typography style={{ fontSize: 20, color: gray }}>{riderNumber}</Typography>
          <Typography style={{ color: gray }}>{numRiders}</Typography>
        </div>
      </Container>
      <table className={classes.rideDetailsTable}>
        <tbody>
          <tr>
            <th className={classes.rideDetailsLeftColumn}>{formatMessage(messages.status)}</th>
            <th className={classes.rideDetailsRightColumn}>{status}</th>
          </tr>
          <tr>
            <th className={classes.rideDetailsLeftColumn}>{formatMessage(messages.startAddress)}</th>
            <th className={classes.rideDetailsRightColumn}>{startAddress}</th>
          </tr>
          <tr>
            <th className={classes.rideDetailsLeftColumn}>{formatMessage(messages.endAddress)}</th>
            <th className={classes.rideDetailsRightColumn}>{endAddress}</th>
          </tr>
          {is_completed && (
            <tr>
              <th className={classes.rideDetailsLeftColumn}>{formatMessage(messages.fare)}</th>
              <th className={classes.rideDetailsRightColumn}>
                <div>
                  {is_completed && payment &&
                    (payment.total_to_charge_display)}
                </div>
              </th>
            </tr>
          )}
          <tr>
            <th className={classes.rideDetailsLeftColumn}>{formatMessage(messages.driverInfo)}</th>
            <th className={classes.rideDetailsRightColumn}>
              <div>{driverName}</div>
              <div>{vehicleDescription}</div>
              {licensePlate && (
                <Button disabled variant="outlined">
                  {licensePlate}
                </Button>
              )}
            </th>
          </tr>
          {expectedDuration && (
            <tr>
              <th className={classes.rideDetailsLeftColumn}>{formatMessage(messages.packageHeader)}</th>
              <th className={classes.rideDetailsRightColumn}>
                <div>{displayPackageDuration()}</div>
              </th>
            </tr>
          )}
        </tbody>
      </table>
      {!is_completed && (
        <Button
          color="primary"
          variant="outlined"
          style={{ margin: 'auto', width: '100%' }}
          onClick={() => cancelTrip()}
        >
          {formatMessage(messages.cancelRide)}
        </Button>
      )}
    </Box>
  );
};

export default withStyles(styles)(injectIntl(RideDetails));
